export const isDefined = <T>(value: T | null | undefined): value is T =>
  value !== undefined && value !== null;

export const isString = (value: unknown): value is string =>
  typeof value === 'string';

export const isArray = (value: unknown): value is unknown[] =>
  Array.isArray(value);

export const isObject = (value: unknown): value is object =>
  typeof value === 'object' && value !== null;

export const isNotBlank = (value: string): boolean => value.trim().length > 0;

export const isSHA1 = (value: string): boolean =>
  /^[0-9a-f]{4,40}$/.test(value);

export const isISODateString = (value: string): boolean =>
  /^\d{4}(-\d{2}){2}T\d{2}(:\d{2}){2}\.\d{1,3}Z$/.test(value);

export const isBaseURL = (value: string): boolean =>
  /^(https?:)?\/{2,}[-\w]+([-:./\w@]+)?$/.test(value);

export const isRelativeFilePath =
  (...extensions: string[]) =>
  (value: string): boolean => {
    const escaped = extensions.map((ext) =>
      ext.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    );
    return new RegExp(`^[-\\w]([-./\\w]+)?\\.(${escaped.join('|')})$`).test(
      value
    );
  };

export const includes =
  (thing: string) =>
  (value: string): boolean =>
    value.includes(thing);

export const endsWith =
  (...strings: string[]) =>
  (value: string): boolean =>
    strings.some((str) => value.endsWith(str));

export const every =
  (...validators: Array<(value: unknown) => boolean>) =>
  (arr: unknown[]): boolean =>
    arr.every((value) => validators.every((validator) => validator(value)));

export const key =
  (name: string, ...validators: Array<(value: unknown) => boolean>) =>
  (obj: Record<string, unknown>): boolean =>
    name in obj && validators.every((validator) => validator(obj[name]));
